
import { faArrowLeft, faArrowRight, faArrowUpFromBracket, faLocationDot } from "@fortawesome/free-solid-svg-icons"
import Icon from "../../components/Icon"
import Container from "../../layout/Container"
import Navbar from "../../layout/Navbar"
import Male from '../../assets/images/male.png'
import Hero from '../../assets/images/hero.png'

import ReviewCard from "../../components/cards/ReviewCard"
import { useParams } from "react-router-dom"
import GuideCardSm from "../../components/cards/GuideCardSm"
import { useFetch } from "../../hooks/useFetch"
import { getGuideById, getGuides } from "../../apis"

import useWidth from "../../hooks/useWidth"
import GuideDetailsMobile from '../mobile/GuideDetails'

import GuideForm from "./GuideForm";
import Loader from "../../components/elements/Loader"
import Share from "../../components/elements/Share"


export default () => {
    const params = useParams()
    const width = useWidth()
    

    const [guide,,loading] = useFetch(getGuideById, {}, params.guideId)
    const [guides] = useFetch(getGuides, [])




    return (
        <>
        <Loader loading={loading} />

            {width < 992 ?  <GuideDetailsMobile guide={guide} /> :
            <>
                <Navbar gradient />
                <Container >
                    <section className="guide-page desktop-top-space">
                        <p className="custom-text-color x-bold text-center  fs-1 guide-page-title">Know Your Guide</p>

                        <div className="row">
                            <div className="col-lg-8 col-md-12 p-0">
                                <div className="d-flex">
                                    <h3 className="custom-text-color">{ guide.name }</h3>
                                    <Share title={guide.name} text={guide.shareDescription || guide.about } />
                                </div>
                                <div className="d-flex profile-section mt-3">
                                    <img src={ guide.file?.Url || Male} className="rounded-4 me-3 mb-3" style={{ width: "150px", height: "150px" }} />
                                    <div>
                                        <p className="custom-text-color"><Icon icon={faLocationDot} className="text-saffron me-3" /> { guide.address }</p>
                                        <p>{ guide.about }</p>
                                    </div>
                                </div>

                                <h6 className="custom-text-color my-4">Top Visits:</h6>
                                <div className="card rounded-4 p-3">
                                    <div className="d-flex flex-wrap">
                                        {
                                            Array(12).fill(0).map(_ =>
                                                <div className="d-flex m-2">
                                                    <div style={{ width: "65px", height: "40px" }}>
                                                        <img src={Hero} className="w-100 h-100 rounded" />
                                                    </div>
                                                    <div className="d-flex flex-column ms-2">
                                                        <p className="bold mb-0 fs-8">{"Harjis Garden"}</p>
                                                        <p className="fs-8">{"650m"}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="d-flex align-items-center mt-5 mb-3">
                                    <h4 className="custom-text-color me-4 mb-0">Ram Kumar Pandit Reviews</h4>
                                    <select className="form-control w-25" style={{ borderRadius: "20px" }}>
                                        <option>Sort By: Most Relevant</option>
                                        <option>Sort By: high to low</option>
                                    </select>
                                </div>

                            </div>

                            <div className="col-lg-4 col-md-12">
                                <GuideForm guide={guide} />
                            </div>
                        </div>
                        <div className="row mt-4">

                            <div className="col-lg-4 col-md-6 col-sm-12 p-0 m-0">
                                <ReviewCard />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 p-0 m-0">
                                <ReviewCard />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 p-0 m-0">
                                <ReviewCard />
                            </div>
                        </div>

                        <p className="custom-text-color my-4">Must Have While Travelling</p>
                        <p className="custom-text-color">
                            - Passport, Aadhar, Driving License, and Govt ID are accepted as ID Proof<br />
                            - Lorem Ipsum Filter<br />
                            - Lorem Ipsum Filter<br />
                            - Lorem Ipsum Filter<br />
                        </p>

                        <div>
                            <h5 className="my-5 text-center">Browse more Guides</h5>
                            <div className="guide-page">
                                <div className="row">
                                    {
                                        guides?.map(( guide, i )=> <div className="col-lg-4 col-md-6" key={i}>
                                            <GuideCardSm guide={guide} />
                                        </div>)
                                    }
                                </div>

                                <div className="d-flex justify-content-center mt-5">
                                    <div className="bg-saffron rounded-circle p-3 mx-2 d-flex  align-items-center justify-content-center cursor-pointer" style={{ width: "50px", height: "50px" }}><Icon icon={faArrowLeft} className="text-white" /></div>
                                    <div className="bg-saffron rounded-circle p-3 mx-2 d-flex  align-items-center justify-content-center cursor-pointer" style={{ width: "50px", height: "50px" }}><Icon icon={faArrowRight} className="text-white" /></div>
                                </div>

                            </div>

                        </div>

                    </section>
                </Container>
                
                
            </>}
        </>
    )
}